import { Component } from '@verndale/core';
import { v4 as uuidv4 } from 'uuid';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      mapContainer: this.el.querySelector('.roundshot-mountain-map__container')
    };

    this.dom.mapContainer.id = uuidv4();
    this.mapApiKey = this.el.dataset.apiKey;
    this.mapJsonUrl = 'https://backend.roundshot.com/embedded/map/185/96';

    this.loadMap();
  }

  async loadMap() {
    const roundshotscript = document.createElement('script');
    roundshotscript.type = 'text/javascript';
    roundshotscript.src =
      'https://backend.roundshot.com/js/roundshot_embedded_map.min.js';
    roundshotscript.async = true;

    this.loadGoogleMaps().then(() => {
      document.body.append(roundshotscript);

      roundshotscript.onload = () => {
        new window.RoundshotMap(this.dom.mapContainer.id, this.mapJsonUrl);
      };
    });
  }

  async loadGoogleMaps() {
    if (window.google?.maps) {
      return Promise.resolve();
    }

    return new Promise(resolve => {
      const googleMapsScript = document.createElement('script');
      googleMapsScript.type = 'text/javascript';
      googleMapsScript.src = `//maps.googleapis.com/maps/api/js?key=${this.mapApiKey}&sensor=false&ver=4.0`;
      googleMapsScript.async = true;
      googleMapsScript.defer = true;
      googleMapsScript.onload = () => {
        resolve();
      };
      document.body.append(googleMapsScript);
    });
  }
}

export default Module;
